class FerBespokeForm extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('.fer-bespoke-form__dialog');
    this.openTriggers = document.querySelectorAll('[data-bespoke-form-open]');
    this.closeTriggers = this.querySelectorAll('[data-bespoke-form-close]');
    this.attachTrigger = this.querySelector('[data-bespoke-form-attach-trigger]');
    this.attachInput = this.querySelector('[data-bespoke-form-attachment]');
    this.referenceField = this.querySelector('#BespokeForm-reference');

    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    });

    this.closeTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.close());
    });

    if (this.attachTrigger && this.attachInput) {
      this.attachTrigger.addEventListener('click', () => this.attachInput.click());
      this.attachInput.addEventListener('change', () => this.handleAttachment());
    }

    if (this.dataset.autoOpen === 'true') {
      this.open(false);
    }
  }

  open(focusDialog = true) {
    this.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
    this.addEventListener('keydown', this.onKeydown);

    if (focusDialog && this.dialog) {
      const focusTarget =
        this.querySelector('[autofocus]') ||
        this.querySelector('input:not([type="hidden"])') ||
        this.dialog;

      if (typeof trapFocus === 'function') {
        trapFocus(this.dialog, focusTarget);
      } else {
        focusTarget.focus();
      }
    }
  }

  close() {
    this.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
    this.removeEventListener('keydown', this.onKeydown);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  handleAttachment() {
    if (!this.attachInput?.files?.length || !this.referenceField) return;

    const fileName = this.attachInput.files[0].name;
    const attachmentNote = `[Attached image: ${fileName}]`;
    const currentValue = this.referenceField.value.trim();

    this.referenceField.value = currentValue
      ? `${currentValue}\n\n${attachmentNote}`
      : attachmentNote;
  }
}

customElements.define('fer-bespoke-form', FerBespokeForm);
